import { render, staticRenderFns } from "./createApplyToSrmTs.vue?vue&type=template&id=d65c5f74"
import script from "./createApplyToSrmTs.vue?vue&type=script&lang=js"
export * from "./createApplyToSrmTs.vue?vue&type=script&lang=js"
import style0 from "./createApplyToSrmTs.vue?vue&type=style&index=0&id=d65c5f74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports